

        //  Scroll to Top functionality
        // const scrollTopBtn = document.getElementById('scrollTop');
        
        // window.addEventListener('scroll', () => {
        //     if (window.pageYOffset > 300) {
        //         scrollTopBtn.classList.add('visible');
        //     } else {
        //         scrollTopBtn.classList.remove('visible');
        //     }
        // });

        // scrollTopBtn.addEventListener('click', () => {
        //     window.scrollTo({
        //         top: 0,
        //         behavior: 'smooth'
        //     });
        // });

        // Smooth scroll for anchor links
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const target = document.querySelector(this.getAttribute('href'));
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
   
        
// =============== Slider section Start ===========
        $(document).ready(function() {
            var $slider = $('.equipment-slider');
            
            // 1. Initialize Slick Carousel with all your settings
            $slider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                dots: true,
                arrows: true,
                infinite: true,
                pauseOnHover: true,
                prevArrow: '<button type="button" class="slick-prev">←</button>',
                nextArrow: '<button type="button" class="slick-next">→</button>',
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
                ]
            });

            $slider.on('setPosition', function(event, slick) {
                if (slick.slideCount <= slick.options.slidesToShow) {
                    $('.slick-dots').hide(); 
                } else {
                    $('.slick-dots').show();
                }
            });

            // 2. Handle the dot/line animation step
            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                var step = nextSlide % 5; 
                $('.slick-dots').attr('data-step', step);
            });
            
            // Set initial dot step
            $('.slick-dots').attr('data-step', 0);
        });
// =============== Slider section End ===========


// ************* add to quote value start ****************

document.addEventListener('click', function(e) {
  const button = e.target.closest('.storeify-quote-btn-trigger-popup');
  
  if (button) {
    const container = button.closest('form, .product-form, .product-single, .storeify-btn-custom-wrapper') || document;
    const sourceQtyInput = container.querySelector('input[name="quantity"][ref="quantityInput"]');
    
    if (sourceQtyInput) {
      const currentQty = sourceQtyInput.value;

      // Start watching the page body for the input to appear
      const modalObserver = new MutationObserver((mutations, observerInstance) => {
        const targetQtyInput = document.getElementById('ify_qty_input');
        
        if (targetQtyInput) {
          observerInstance.disconnect(); // Stop watching instantly once found
          
          targetQtyInput.value = currentQty;
          targetQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          targetQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('Synced quantity via Observer:', currentQty);
        }
      });

      // Watch body for any newly added HTML elements
      modalObserver.observe(document.body, { childList: true, subtree: true });

      // Safety timeout: stop watching after 3 seconds if the user closes the modal or it fails
      setTimeout(() => modalObserver.disconnect(), 3000);
    }
  }
});

// ************* add to quote value end ****************


      //search functionality start

      const box = document.querySelector('.search-box'), 
            list = document.querySelector('.search_product_list'), 
            cont = document.querySelector('.search-container'), 
            inp = document.querySelector('.search_filter input');

      // Open list on box click
      box.onclick = (e) => (e.stopPropagation(), list.classList.add('active'));

      // Open container on input focus
      inp.onfocus = (e) => (e.stopPropagation(), cont.classList.add('active'));

      // NEW: Open list on search-action click (handles multiple elements if they exist)
      document.querySelectorAll('.search-action').forEach(btn => {
          btn.onclick = (e) => {(e.stopPropagation(), list.classList.add('active')),(e.stopPropagation(), cont.classList.add('active'))};
      });

      // Close elements on outside click
        document.onclick = (e) => { 
            if (e.target.closest('.search_cross_icon') || !e.target.closest('.search-box, .search_product_list, .search-container, .search-action')) { 
                [list, cont].forEach(el => el.classList.remove('active')); 
            } 
        };


  //********************custom search start******************

          let debounceTimeout;
          const searchInput = document.getElementById('custom-search-input');
          const resultsContainer = document.getElementById('custom-search-dropdown');

          // Capture the pre-rendered metaobject HTML to display when input is empty
          const defaultSearchHTML = resultsContainer.innerHTML;

          searchInput.addEventListener('keyup', (event) => {
            const query = event.target.value.trim();

            clearTimeout(debounceTimeout);

            // If user backs out completely, snap back to initial metaobject blocks
            if (query.length === 0) {
              resultsContainer.innerHTML = defaultSearchHTML;
              return;
            }

            // Restrict execution until at least 2 characters are registered
            if (query.length < 2) return;

            debounceTimeout = setTimeout(() => {
              fetchResults(query);
            }, 300);
          });

        // **********backup older code start**********

          // function fetchResults(query) {
          //   const endpoint = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&section_id=custom-live-search`;

          //   fetch(endpoint)
          //     .then(response => {
          //       if (!response.ok) throw new Error('Prediction API failure');
          //       return response.text();
          //     })
          //     .then(htmlContent => {
          //       const parser = new DOMParser();
          //       const responseDocument = parser.parseFromString(htmlContent, 'text/html');
                
          //       // Shopify embeds responses inside an outer wrapper div based on the section filename
          //       const liveResults = responseDocument.getElementById('shopify-section-custom-live-search');

          //       if (liveResults && liveResults.innerHTML.trim() !== "") {
          //         resultsContainer.innerHTML = liveResults.innerHTML;
          //       }
          //     })
          //     .catch(error => {
          //       console.error('Dynamic Live Search system breakdown:', error);
          //     });
          // }
        // **********backup older code end**********

          // show only single product if get multiple products of same name start
          function fetchResults(query) {
            const endpoint = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&section_id=custom-live-search`;

            fetch(endpoint)
              .then(response => {
                if (!response.ok) throw new Error('Prediction API failure');
                return response.text();
              })
              .then(htmlContent => {
                const parser = new DOMParser();
                const responseDocument = parser.parseFromString(htmlContent, 'text/html');
                
                // Shopify embeds responses inside an outer wrapper div based on the section filename
                const liveResults = responseDocument.getElementById('shopify-section-custom-live-search');

                if (liveResults && liveResults.innerHTML.trim() !== "") {
                  
                  // 1. Target your exact product items
                  const products = liveResults.querySelectorAll('.product-item');
                  const seenNames = new Set();

                  products.forEach(product => {
                    // 2. Target your exact span class for titles
                    const nameElement = product.querySelector('.product-name');
                    
                    if (nameElement) {
                      const productName = nameElement.textContent.trim().toLowerCase();

                      if (seenNames.has(productName)) {
                        // 3. Remove duplicate node if title already exists in Set
                        product.remove();
                      } else {
                        // 4. Track original unique title
                        seenNames.add(productName);
                      }
                    }
                  });

                  // 5. Render cleaned markup to your search box
                  resultsContainer.innerHTML = liveResults.innerHTML;
                }
              })
              .catch(error => {
                console.error('Dynamic Live Search system breakdown:', error);
              });
          }
          // show only single product if get multiple products of same name start

          // **********backup older code start**********


      // on hover the collection show matching products start*********
        document.addEventListener('DOMContentLoaded', () => {
          const searchInput = document.getElementById('custom-search-input');
          const resultsContainer = document.getElementById('custom-search-dropdown');

          // Listen for mouseover (hover) events across your matching list collections
          resultsContainer.addEventListener('mouseover', (event) => {
            const collectionLink = event.target.closest('[data-collection-handle]');
            if (!collectionLink) return;

            const collectionHandle = collectionLink.getAttribute('data-collection-handle');
            const currentQuery = searchInput.value.trim();

            if (!collectionHandle) return;

            // Prevent excessive layout flickering with a short 120ms hover debounce safety guard
            if (collectionLink.dataset.hoverTimeout) {
              clearTimeout(parseInt(collectionLink.dataset.hoverTimeout));
            }

            collectionLink.dataset.hoverTimeout = setTimeout(() => {
              fetchIsolatedCollectionProducts(currentQuery, collectionHandle);
            }, 120);
          });

          // Reset timers on mouse exit
          resultsContainer.addEventListener('mouseout', (event) => {
            const collectionLink = event.target.closest('[data-collection-handle]');
            if (!collectionLink) return;

            if (collectionLink.dataset.hoverTimeout) {
              clearTimeout(parseInt(collectionLink.dataset.hoverTimeout));
            }
          });

          /**
           * Directly hits the backend collection engine bypassing general store search parameters
           */
          function fetchIsolatedCollectionProducts(query, collectionHandle) {
            const productsTargetWrapper = resultsContainer.querySelector('.products-list');
            if (!productsTargetWrapper) return;

            // Direct endpoint query hitting the custom layout section built in Step 1
            const collectionApiUrl = `/collections/${collectionHandle}?q=${encodeURIComponent(query)}&section_id=collection-search-filter`;

            // Dim the section briefly to show an ongoing search transition state
            productsTargetWrapper.style.opacity = '0.35';

            fetch(collectionApiUrl)
              .then(response => {
                if (!response.ok) throw new Error('Collection endpoint inaccessible');
                return response.text();
              })
              .then(htmlMarkup => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlMarkup, 'text/html');
                
                // Isolate the element template rendered inside our theme section engine
                const filteredSection = doc.getElementById('isolated-products-output');

                if (filteredSection) {
                  // Replace the primary products display with the freshly filtered collection block
                  productsTargetWrapper.innerHTML = filteredSection.innerHTML;
                } else {
                  productsTargetWrapper.innerHTML = '<div class="no-match-msg" style="padding:15px; width:100%; text-align:center; color:#888;">No products found in this category.</div>';
                }
                productsTargetWrapper.style.opacity = '1';
              })
              .catch(error => {
                console.error('Isolated product stream collection error:', error);
                productsTargetWrapper.style.opacity = '1';
              });
          }
        });
      // on hover the collection show matching products end***********

        // UPDATED FEATURE: Redirect to a product-only search results page on icon click
        document.addEventListener('DOMContentLoaded', () => {
          const searchIcon = document.querySelector('#search-icon');
          const searchInput = document.getElementById('custom-search-input');

          if (!searchIcon || !searchInput) return;
          
          // Function to handle the redirect logic
          function performSearch() {
            const query = searchInput.value.trim();
            if (!query) return;

            // Appending * allows partial strings (like 'pla') to match complete words (like 'plates')
            // const predictiveQuery = `${query}*`;
            const predictiveQuery = `title:${query} OR tag:${query} OR collection:${query}`;
            // const predictiveQuery = `title:${query}`;

            // Redirects to standard product search page with the prefix wildcard enabled
            window.location.href = `/search?type=product&options[prefix]=last&q=${encodeURIComponent(predictiveQuery)}`;
            
          }

        // latest code filter the single product from the multiple repeated products on the seach result page start **********          
          (function() {
            function filterSearchPageDuplicates() {
              // 1. Target the actual product grid items (the <li> tags)
              const products = document.querySelectorAll('li.product-grid__item');
              if (!products.length) return;

              const seenNames = new Set();

              products.forEach(product => {
                // 2. Extract the hidden text containing the product title string
                const nameElement = product.querySelector('.product-card__link .visually-hidden');
                
                if (nameElement) {
                  const productName = nameElement.textContent.trim().toLowerCase();

                  // 3. Keep the 1st unique version found and eliminate subsequent ones
                  if (seenNames.has(productName)) {
                    product.remove();
                  } else {
                    seenNames.add(productName);
                  }
                }
              });
            }

            // Run as early as possible when content loads
            document.addEventListener("DOMContentLoaded", filterSearchPageDuplicates);

            // Run immediately if the page parsing loop has already crossed the ready threshold
            if (document.readyState === "interactive" || document.readyState === "complete") {
              filterSearchPageDuplicates();
            }

            // 4. Create an observer to catch and clean elements injected later via Infinite Scroll
            const targetNode = document.querySelector('main') || document.body;
            if (targetNode) {
              const observer = new MutationObserver((mutations) => {
                // Debounce slightly to ensure rendering updates finish safely
                filterSearchPageDuplicates();
              });
              observer.observe(targetNode, { childList: true, subtree: true });
            }
          })();
        // latest code filter the single product from the multiple repeated products on the seach result page end **********          


          // 1. Click event for the search icon
          searchIcon.addEventListener('click', performSearch);

          // 2. Keydown event for the input field (triggers on Enter)
          searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              performSearch();
            }
          });

        });

  //******************custom search end*****************



//search functionality end














